import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ icon, title, value, change, changeType, description }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-md border border-border transition-smooth hover-lift">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10">
          <Icon name={icon} size={20} color="var(--color-primary)" className="md:w-6 md:h-6" />
        </div>
        {change && (
          <div className={`flex items-center gap-1 text-xs md:text-sm font-medium ${getChangeColor()}`}>
            <Icon name={getChangeIcon()} size={14} className="md:w-4 md:h-4" />
            <span>{change}</span>
          </div>
        )}
      </div>
      <h3 className="text-xs md:text-sm text-muted-foreground font-medium mb-1 md:mb-2">{title}</h3>
      <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-1 md:mb-2 text-data">{value}</p>
      {description && (
        <p className="text-xs md:text-sm text-muted-foreground">{description}</p>
      )}
    </div>
  );
};

export default MetricsCard;